import request from '@/utils/request'

/**
 * Transaction Reasons API
 * Base URL: /api/v1/data
 */

/**
 * Get all income transaction reasons
 * @returns {Promise} Response with income transaction reasons array
 */
export const getIncomeTransactionReasons = () => request.get('/data/income-transaction-reasons')

/**
 * Get income transaction reasons as options (English labels)
 * @returns {Promise} Response with income transaction reasons as options
 */
export const getIncomeTransactionReasonOptions = () => request.get('/data/income-transaction-reasons/options')

/**
 * Get income transaction reasons as options (Arabic labels)
 * @returns {Promise} Response with income transaction reasons as options
 */
export const getIncomeTransactionReasonOptionsAr = () => request.get('/data/income-transaction-reasons/options-ar')

/**
 * Get all expense transaction reasons
 * @returns {Promise} Response with expense transaction reasons array
 */
export const getExpenseTransactionReasons = () => request.get('/data/expense-transaction-reasons')

/**
 * Get expense transaction reasons as options (English labels)
 * @returns {Promise} Response with expense transaction reasons as options
 */
export const getExpenseTransactionReasonOptions = () => request.get('/data/expense-transaction-reasons/options')

/**
 * Get expense transaction reasons as options (Arabic labels)
 * @returns {Promise} Response with expense transaction reasons as options
 */
export const getExpenseTransactionReasonOptionsAr = () => request.get('/data/expense-transaction-reasons/options-ar')
